module.exports = __webpack_public_path__ + "static/message-kv-68df99bee667349e3424427b9e732da9.jpg";